/**
 * Column Utility Functions
 * 
 * Pure functions for column ordering and localStorage persistence
 */

import { sortStatusesByCategory } from '../../FlowchartView/utils/statusUtils';

// LocalStorage key for collapsed columns
const COLLAPSED_COLUMNS_KEY = 'kanban-collapsed-columns';

/**
 * Get columns in the correct order
 * Uses kanbanColumnOrder if available, otherwise falls back to category-based sort
 */
export const getOrderedColumns = (statuses, kanbanColumnOrder) => {
  const sortedByCategory = sortStatusesByCategory(statuses);
  
  if (!kanbanColumnOrder || kanbanColumnOrder.length === 0) {
    return sortedByCategory;
  }
  
  // Build ordered array based on kanbanColumnOrder
  const ordered = [];
  const remaining = [...sortedByCategory];
  
  for (const statusId of kanbanColumnOrder) {
    const index = remaining.findIndex(s => s.id === statusId);
    if (index !== -1) {
      ordered.push(remaining[index]);
      remaining.splice(index, 1);
    }
  }
  
  // Add any new statuses that weren't in the saved order (at the end)
  ordered.push(...remaining);
  
  return ordered;
};

/**
 * Get stored collapsed columns from localStorage for a specific campaign
 */
export const getStoredCollapsedColumns = (campaignId) => {
  if (!campaignId) return new Set();
  try {
    const stored = localStorage.getItem(`${COLLAPSED_COLUMNS_KEY}_${campaignId}`);
    return stored ? new Set(JSON.parse(stored)) : new Set();
  } catch {
    return new Set();
  }
};

/**
 * Save collapsed columns to localStorage for a specific campaign
 */
export const saveCollapsedColumns = (campaignId, collapsedSet) => {
  if (!campaignId) return;
  try {
    localStorage.setItem(`${COLLAPSED_COLUMNS_KEY}_${campaignId}`, JSON.stringify([...collapsedSet]));
  } catch (e) {
    console.warn('Failed to save collapsed columns:', e);
  }
};

